import * as Stores from '../stores'

export function useMyLowesRewardsEnrollment({ email }: { email: string }) {
  const skipQuery = !email || email === ''

  const myLowesRewardsEnrollment = Stores.CardBenefitsApi.endpoints[
    'GET /benefits/lowes-rewards-status'
  ].useQuery(
    { query: { email } },
    {
      skip: skipQuery,
      selectFromResult({ data, isLoading, isUninitialized, isSuccess, error }) {
        return {
          isUninitialized,
          isLoading,
          isSuccess,
          error,
          data: data?.enrolled ?? false,
        }
      },
    },
  )

  return myLowesRewardsEnrollment
}
